<div class="fw fh">
    <router-outlet></router-outlet>
</div>